import { render, staticRenderFns } from "./HostedFields.vue?vue&type=template&id=69838ec4&"
import script from "./HostedFields.vue?vue&type=script&lang=js&"
export * from "./HostedFields.vue?vue&type=script&lang=js&"
import style0 from "./HostedFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HostedFields.vue"
export default component.exports